import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './StepHeadding.scss';

const SIGN_IN_FORM = 'SIGN_IN_FORM';
const SIGN_UP_FORM = 'SIGN_UP_FORM';

class StepHeadding extends Component {
  selectForm = () => {
    const {
      selectForm,
      stepTitle,
    } = this.props;

    if (stepTitle === 'Sign in') {
      selectForm(SIGN_IN_FORM);
    } else {
      selectForm(SIGN_UP_FORM);
    }
  }

  steps = {
    one: '1',
    two: '2',
    three: '3',
  }

  render() {
    return (
      <div className={styles.root}>
        <div className={styles.content}>
          <div className={styles.step}>Step {this.steps[this.props.stepNumber]} of 3</div>
          <div className={styles.title}>{this.props.stepTitle}</div>
          {
            (this.props.stepNumber === 'one' && !this.props.authenticated) &&
            <div className={styles.linkContainer}>
              <span>{this.props.stepTitle === 'Sign in' ? 'New to Racing Post?' : 'Already Registered?'}</span>

              <span className={`${styles.link} ui-link_secondary`} onClick={this.selectForm}>
                {this.props.stepTitle === 'Sign in' ? 'Register' : 'Sign in'}
              </span>
            </div>
          }
          {this.props.stepNumber === 'three' &&
          <div
            className={styles.subtitle}>Choose Payment Type*
          </div>}
        </div>
      </div>
    );
  }
}

StepHeadding.propTypes = {
  selectForm: PropTypes.func,
};

export default StepHeadding;
